import TransactionStorage from "./TransactionStorage.js";

export default function() {
	if(!window.caches) {
		return Promise.resolve();
	}
	return caches.keys()
		.then(cacheNames => {
			return cacheNames;
		})
		.then(cachesToDelete => {
			return Promise.all(cachesToDelete.map(cacheToDelete => {
				return caches.delete(cacheToDelete);
			}));
		})
		.then(() => {
			return TransactionStorage.clear();
		})
		.then(() => {
			console.log('cleared caches');
		});
};